import { accessoSchema, type AccessoInput } from '@aulaviva/shared';
import { Alert, Button, PasswordField, PageHeading, TextField } from '@aulaviva/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useAccesso } from '@/api/auth';
import { ErroreRichiesta } from '@/api/client';
import { homePerRuolo } from '@/lib/ruoli';
import { auth } from '@/testi';

export function Accedi() {
  const t = auth.accedi;
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const accesso = useAccesso();
  const [errore, setErrore] = useState<string | null>(null);
  const { register, handleSubmit, formState } = useForm<AccessoInput>({ resolver: zodResolver(accessoSchema) });

  async function invia(dati: AccessoInput) {
    setErrore(null);
    try {
      const esito = await accesso.mutateAsync(dati);
      if (esito.esito === 'codice_richiesto') {
        navigate(`/nuovo-dispositivo?email=${encodeURIComponent(esito.email)}`);
        return;
      }
      if (esito.esito === 'totp_richiesto') {
        navigate(`/codice-autenticazione?email=${encodeURIComponent(esito.email)}${params.get('dopo') ? `&dopo=${encodeURIComponent(params.get('dopo')!)}` : ''}`);
        return;
      }
      navigate(params.get('dopo') ?? homePerRuolo(esito.utente.ruolo), { replace: true });
    } catch (e) {
      if (e instanceof ErroreRichiesta && e.codice === 'email_non_verificata') {
        navigate(`/verifica-email?email=${encodeURIComponent(dati.email)}&avviso=non-verificata`);
        return;
      }
      if (e instanceof ErroreRichiesta && e.status === 401) setErrore(t.credenzialiErrate);
      else setErrore(e instanceof Error ? e.message : t.credenzialiErrate);
    }
  }

  return (
    <>
      <PageHeading size="display" subtitle={t.sottotitolo}>
        {t.titolo}
      </PageHeading>
      <form onSubmit={handleSubmit(invia)} noValidate className="flex flex-col gap-6">
        {errore && <Alert variant="error" title={errore} />}
        <TextField label={auth.campi.email} type="email" autoComplete="email" error={formState.errors.email?.message} {...register('email')} />
        <PasswordField label={auth.campi.password} autoComplete="current-password" error={formState.errors.password?.message} {...register('password')} />
        <Button type="submit" variant="primary" size="lg" fullWidth loading={accesso.isPending} loadingText={t.inCorso}>
          {t.azione}
        </Button>
      </form>
      <p className="t-body text-ink-muted">
        {t.nonHaiAccount} <Link to="/registrati">{t.registrati}</Link>
      </p>
    </>
  );
}
